import React, { useEffect, useRef } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Header from './../../compoments/Header'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import MaterialTable, { MTableToolbar } from 'material-table'
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import api from './../../services/axios'
import { Redirect } from 'react-router'
import Paper from '@material-ui/core/Paper';
import { jsPDF } from "jspdf";
import 'jspdf-autotable'
import AlertDialog from './../../compoments/AlertDialog'
import DatePicker from './../../compoments/DatePicker';
import TimePickerCustom from './../../compoments/TimePickerCustom';
import Loading from './../../compoments/Loading'
import MaterialTableComponent from './../../compoments/MaterialTableComponent'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem'
import { Modal } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { baseURL } from './../../env.js'

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'row',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperModal: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fixedHeight: {
    height: 240,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: '100%',
  },
}));

export default function Login() {

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };


  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const role = 'ope';
  const roleName = 'Logins / Logout';
  const theme = useTheme();
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [redirect, setRedirect] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [openModalLogof, setOpenModalLogof] = React.useState(false);
  const [login, setLogin] = React.useState(null);
  const [start, setStart] = React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(0)
    dt.setMinutes(0);
    return dt;
  });
  const [filaId, setFilaId] = React.useState('');
  const [userId, setUserId] = React.useState('');
  const [end, setEnd] = React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(23)
    dt.setMinutes(59);
    return dt;
  });
  const [title, setTitle] = React.useState('');
  const [filas, setFilas] = React.useState([]);
  const [filasSelected, setFilasSelected] = React.useState([]);
  const [operadores, setOperadores] = React.useState([]);
  const [personName, setPersonName] = React.useState([]);
  const [operador, setOperador] = React.useState(null);
  const [inputValue, setInputValue] = React.useState('');
  const [urlPdf, setUrlPdf] = React.useState('');
  const [startStr, setStartStr] = React.useState('');
  const [endStr, setEndStr] = React.useState('');
  const [dataPrint, setDataPrint] = React.useState([]);
  const [somenteLogados, setSomenteLogados] = React.useState(true);
  const [sendLogofLoading, setSendLogofLoading] = React.useState('');


  const sendLogof = async () => {

    setSendLogofLoading('disabled');

    const dateToString = (date, time) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      const yyyy = date.getFullYear();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
  
      let timeString = '';
      if (time) {
        timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
      }
      return yyyy + '-' + mm + '-' + dd + '' + timeString;
    }

    const user = new FormData();
    if(login && login.login){
      user.append('login', dateToString(new Date(login.login), true))
    }
    console.log('end', end)
    if(end){
      user.append('logout', dateToString(new Date(end), true))
    }
    user.append('_method', 'PUT')
    try { 
      const data = await api.post('/v1/gerencia/logins/' + login.id, user, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      });
      setSendLogofLoading('');
      setOpenModalLogof(!openModalLogof)
      loadData(start, end)
      // if(data.status){
      //   setAlertTitle('')
      //   setRedirect(`/gerencia/logins`)
      // }
    } catch(error) {
      setSendLogofLoading('');
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }

  }

  const loadFilas = async () => {
    const data = await api.get('/v1/queue-table?order=id&orderType=desc')
    setFilas(data.data.data)
  }
  const loadOperadores = async () => {
    const data = await api.get('/v1/operadores?role=ope')
    setOperadores(data.data.data)
  }

  const loadData = async (a, b) => {
    setLoading(true)
    const dateToString = (date, time) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      const yyyy = date.getFullYear();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      let timeString = '';
      if (time) {
        // timeString = ' '+hours.toString().padStart(2, '0') + ':' + 
        //   minutes.toString().padStart(2, '0') + ':' + 
        //   seconds.toString().padStart(2, '0');
        timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');

      }
      return yyyy + '-' + mm + '-' + dd + '' + timeString;
    }
    const getTime = (date) => {
      return new Date(date).toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
    }
    setStartStr(dateToString(start, true));
    setEndStr(dateToString(end, true));

    let url = '/v1/gerencia/logins?&logged=1';
    
    setUrlPdf(url);

    const data = await api.get(url)
    setLoading(false)

    const dt = data.data.data.map((i) => {
      return {
        id: i.id,
        operador: i.operador,
        loginDate: i.loginDate,
        loginH: i.loginH,
        logoutH: i.logoutH,
        duration: i.duration,
        login: i.login,
        logout: i.logout,
        lastHour: i.lastHour,
        cod: i.cod,
      }
    })
    setData(dt)
  }

  useEffect(() => {
    loadFilas()
    loadOperadores()
    loadData(start, end)
  }, [])

  const search = () => {
    setTitle('de ' + start + ' até ' + end)
    loadData(start, end)
  }


  const downloadCsv = (data, fileName) => {
    const finalFileName = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
    a.setAttribute("download", finalFileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const tableRef = useRef();

  return (
    <div className={classes.root}>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        className={classes.modal}
        open={openModalLogof}
        // onClose={() => setOpenModalLogof(!openModalLogof)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.paperModal}>
          <Grid item xs={8} style={{ alignSelf: 'center' }}>
            <DatePicker
              disabled={sendLogofLoading}
              value={end}
              onChange={setEnd}
              label={'Data da saída'}
            />
            <TimePickerCustom
              disabled={sendLogofLoading}
              value={end}
              onChange={setEnd}
              label={'Hora da saída'}
            />
          </Grid>

          <Grid item xs={12} style={{marginTop: 30}}>
            <Button
              disabled={sendLogofLoading}
              onClick={() => setOpenModalLogof(!openModalLogof)}
              type="button"
              variant="contained"
              color="default"
              style={{ marginRight: 30 }}
            >
              Cancelar
            </Button>
            <Button
              disabled={sendLogofLoading}
              id="sendLogofBt"
              type="button"
              variant="contained"
              color="secondary"
              onClick={sendLogof}
            >
              {sendLogofLoading==='disabled' ? 'Deslogando...' : 'Deslogar operador'}
            </Button>
          </Grid>
        </div>
      </Modal>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      {/* TOPO E MENU DRAWER*/}
      <Header />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Typography color="textPrimary">{roleName}</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              {loading ? <Loading /> :
                <MaterialTableComponent
                  tableRef={tableRef}
                  // components={{
                  //   Toolbar: props => (
                  //     <>
                  //       <Grid container spacing={3} style={{ paddingLeft: 20, paddingBottom: 20 }}>
                  //         <Grid item xs={3} style={{ alignSelf: 'center' }}>
                  //           <DatePicker
                  //             value={start}
                  //             onChange={setStart}
                  //             label={'Data'}
                  //           />
                  //         </Grid>
                  //         <Grid item xs={3} style={{ alignSelf: 'center' }}>
                  //           <TimePickerCustom
                  //             value={start}
                  //             onChange={setStart}
                  //             label={'Hora'}
                  //           />
                  //         </Grid>
                  //         <Grid item xs={3} style={{ alignSelf: 'center' }}>
                  //           <DatePicker
                  //             value={end}
                  //             onChange={setEnd}
                  //             label={'Até a data'}
                  //           />
                  //         </Grid>
                  //         <Grid item xs={3} style={{ alignSelf: 'center' }}>
                  //           <TimePickerCustom
                  //             value={end}
                  //             onChange={setEnd}
                  //             label={'Até a Hora'}
                  //           />
                  //         </Grid>
                  //       </Grid>
                  //       <Grid container spacing={3} style={{ paddingLeft: 20, paddingBottom: 20 }}>
                  //         <Grid item xs={6} style={{ alignSelf: 'center' }}>
                  //           <Autocomplete
                  //             value={operador}
                  //             onChange={(event, newValue) => {
                  //               setOperador(newValue);
                  //             }}
                  //             id="combo-box-demo"
                  //             options={operadores}
                  //             getOptionLabel={(option) => option.cod + ' - ' + option.name}
                  //             renderInput={(params) => <TextField value={userId} {...params} label="Operador" variant="outlined" />}
                  //           />
                  //         </Grid>
                  //         <Grid item xs={3} style={{ alignSelf: 'center' }}>
                  //           <FormControlLabel
                  //               control={
                  //                 <Checkbox
                  //                   checked={somenteLogados}
                  //                   onChange={()=>setSomenteLogados(!somenteLogados)}
                  //                   name="somenteLogados"
                  //                   color="primary"
                  //                 />
                  //               }
                  //               label="Somente logados"
                  //             />
                  //         </Grid>
                  //         <Grid item xs={12} style={{ alignSelf: 'center', marginTop: 20 }}>
                  //           <Button
                  //             type="button"
                  //             variant="contained"
                  //             color="primary"
                  //             onClick={search}
                  //           >
                  //             Gerar
                  //         </Button>
                  //         </Grid>
                  //         <Grid item xs={12} style={{ alignSelf: 'center', marginTop: 20 }}>
                  //           <MTableToolbar {...props} />
                  //         </Grid>
                  //       </Grid>
                  //     </>)
                  // }}
                  columns={[
                    { title: 'Operador', field: 'operador' },
                    { title: 'Cod.', field: 'cod' },
                    { title: 'Data', field: 'loginDate' },
                    { title: 'Entrada', field: 'loginH' },
                    { title: 'Saída', field: 'logoutH' },
                    // { title: 'Duração', field: 'duration' },
                  ]}
                  actions={[
                    {
                      icon: 'undo',
                      tooltip: 'Deslogar',
                      onClick: (event, rowData) => {
                        if(rowData.logout.trim().length>0){
                          alert('Logof já realizado')
                        }else{
                          const logoutDefault = rowData && rowData.logout || rowData && rowData.lastHour;
                          setEnd(new Date(logoutDefault))
                          setOpenModalLogof(!openModalLogof)
                          setLogin(rowData);
                        }
                      }
                    },
                    {
                      icon: 'edit',
                      tooltip: 'Editar',
                      onClick: (event, rowData) => {
                        setRedirect(`/gerencia/logins/update/${rowData.id}`)
                      }
                    },
                  ]}
                  data={data}
                  title={''}
                  options={{
                    actionsColumnIndex: -1,
                    exportDelimiter: ';',
                    exportButton: false
                  }}
                />
              }
            </Grid>
            <AlertDialog message={message}
              onClose={() => setMessage(false)}
              title={alertTitle}
              buttonSuccessText={'OK'}
            />
          </Grid>
        </Container>
      </main >
    </div >
  );
}